export const PROJECT_NAME = "NRTAIL";
export const PROJECT_DELIVERY_NAME = "NRTAIL DELIVERY";
export const PROJECT_CUSTOMER_NAME = "NRTAIL CUSTOMER";
export const ALERT_TIME_OUT = 3000;
//export const API_BASE_URL = "http://localhost:3002/api";
//export const API_BASE_URL = "http://154.61.75.36:3020/api";
export const API_BASE_URL = "http://nrtailjs.nisanapps.com:3002/api";
export const BASE_MOBILE_API_URL = `${API_BASE_URL}/mobile`;
export const BASE_WEB_REPORTS_API_URL = `${API_BASE_URL}/web/report`;
export const BASIC_AUTH = "Basic NRTAIL@321";

export const formatDateForDatabase = (date) => {
  if (!date) return null; // Handle the case where the date is null or undefined

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
  const day = String(date.getDate()).padStart(2, "0"); // Ensure 2-digit day

  return `${year}-${month}-${day}`;
};

export const formatMonthDate = (date) => {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d)) return date;

  const year = d.getFullYear();
  const day = String(d.getDate()).padStart(2, "0");

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const month = months[d.getMonth()];

  return `${day}-${month}-${year}`;
};

export const getCurrentLocation = () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => reject(error),
      {
        enableHighAccuracy: true,
        timeout: 10000,
      },
    );
  });
};

// Helper to format dates for API
export const formatDateForAPI = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
